import React, {useMemo} from 'react';
import {LeftOutlined, RightOutlined} from "@ant-design/icons";
import {Button, Layout, Typography} from "antd";
import ModelViewerTile from "./ModelViewerTile";
import {useGLTF} from "@react-three/drei";
import {useLoader} from "@react-three/fiber";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";

const { Title, Text } = Typography;

const TexturingResults = ({path, prompt, onBackTap, results, generationTime, isVolumetric, generateAgain}) => {
    const size = "24rem";

    return (
        <div className="relative bg-black h-screen">
            <Layout>
                <div className="absolute top-20 left-16">
                    <Button
                        type="text"
                        icon={<LeftOutlined />}
                        onClick={onBackTap}
                    />
                </div>

                <div style={{display: "flex", marginLeft: "4rem", marginTop: "4rem", justifyContent: "center", flexDirection: "row-reverse"}}>
                    <div style={{
                        backgroundColor: "#313131",
                        width: "30rem",
                        height: "16rem",
                        transform: "translateX(-3rem)",
                        borderRadius: 32
                    }}>
                        <div className="flex flex-col gap-1 justify-center" style={{marginLeft: "5rem", height: "100%", marginRight: "5rem", fontFamily: "Avenir"}}>
                            <Title
                                level={5}
                                className="text-white font-medium text-left"
                            >
                                {prompt}
                            </Title>
                            <p className="text-gray-400 font-medium text-left text-base">
                                Number of results: {results.length}
                                <br/>
                                Generation time: {Math.round(generationTime / 1000)}s
                            </p>
                            {
                                isVolumetric ?
                                    <Button
                                        type="primary"
                                        shape="round"
                                        style={{fontFamily: "Avenir", width: "12rem", height: "3rem", fontSize: 18}}
                                        onClick={generateAgain}
                                    >
                                        Generate again
                                    </Button>
                                    : <div/>
                            }
                        </div>
                    </div>
                    <ModelViewerTile
                        width={"16rem"}
                        height={"16rem"}
                        glbPath={path}
                        rotation={isVolumetric ? [Math.PI / 2, Math.PI, 0] : [Math.PI, Math.PI / 2, -Math.PI / 2]}
                        camera={isVolumetric ? { position: [-1, 20, 20], fov: 10 } : { position: [-10, 15, 25], fov: 5 }}
                    />
                </div>

                <div className="flex flex-wrap gap-12 justify-center" style={{marginTop: "4rem"}}>
                    { results.map( item => {
                        return <ModelViewerTile
                            className="basis-auto"
                            width={size}
                            height={size}
                            hoverShadow={true}
                            showFullScreen={false}
                            showDownload={true}
                            glbPath={path}
                            texturePath={item}
                            rotation={isVolumetric ? [Math.PI / 2, Math.PI, 0] : [Math.PI, Math.PI / 2, -Math.PI / 2]}
                            camera={isVolumetric ? { position: [-1, 20, 20], fov: 10 } : { position: [-10, 15, 25], fov: 5 }}
                        />
                    })}
                </div>
            </Layout>

        </div>
    );
};

export default TexturingResults;